import { Instance } from 'mobx-state-tree';
import { TeamMemberUpdatedDtoModelBase } from './TeamMemberUpdatedDtoModel.base';

/* The TypeScript type of an instance of TeamMemberUpdatedDtoModel */
export interface TeamMemberUpdatedDtoModelType extends Instance<typeof TeamMemberUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for TeamMemberUpdatedDtoModel */
export { selectFromTeamMemberUpdatedDto, teamMemberUpdatedDtoModelPrimitives, TeamMemberUpdatedDtoModelSelector } from './TeamMemberUpdatedDtoModel.base';

/**
 * TeamMemberUpdatedDtoModel
 */
export const TeamMemberUpdatedDtoModel = TeamMemberUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
